/**
 * Iter 82 — Punto rojo pequeño que se muestra en los botones "Guardar"
 * cuando el formulario tiene cambios sin guardar.
 *
 * Uso:
 *   <button>
 *     <UnsavedDot show={isDirty} />
 *     <Save size={14} /> Guardar
 *   </button>
 */
export default function UnsavedDot({ show }) {
  if (!show) return null;
  return (
    <span
      aria-label="Cambios sin guardar"
      title="Tienes cambios sin guardar"
      data-testid="unsaved-dot"
      className="inline-block w-2 h-2 rounded-full bg-red-500 animate-pulse mr-0.5"
    />
  );
}
